import React from "react";

type PartnersSectionProps = {
  partnerLogos: string[];
};

const PartnersSection: React.FC<PartnersSectionProps> = ({ partnerLogos }) => (
  <>
    {/* ── Large-screen layout (>500px) ── */}
    <div className="
      bg-[#F5F7FA] py-[120px] px-20 flex flex-col md:flex-row justify-between gap-10
      max-[500px]:hidden
    ">
      <div className="max-w-xl">
        <p className="font-inter font-semibold text-[22px] leading-[150%] tracking-[-0.005em] bg-gradient-to-t from-[#46C1BF] to-[#46C1BF] bg-clip-text text-transparent mb-4">
          Our Partners //
        </p>
        <h2 className="font-utility font-medium text-[54px] leading-[120%] tracking-[-0.01em] capitalize text-[#011621] mb-8">
          Trusted By Leading Brands, Powered By Excellence
        </h2>
        <p className="font-inter font-normal text-[20px] leading-[150%] tracking-[-0.005em] text-[#033652] w-[515px]">
         At Sktuff, we collaborate with top glass manufacturers and trusted brands across industries to deliver uncompromising quality and precision. These long-standing partnerships power our ability to innovate, craft with care, and deliver world-class glass solutions, making us India's preferred processing partner.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-8 md:mt-0">
        {partnerLogos.map((logo, index) => (
          <div
            key={index}
            // className="bg-white p-6 w-full max-w-[150px] h-[150px] flex items-center justify-center shadow-sm"
          >
            <img
              src={logo}
              alt="Partner Logo"
              className="max-h-[150px] object-contain w-auto mx-auto"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>

    {/* ── Small-screen layout (≤500px) ── */}
    <div className="
      bg-[#F5F7FA] py-16 px-4 flex flex-col justify-between gap-10
      hidden max-[500px]:flex
    ">
      <div>
        <p className="font-inter font-semibold text-base leading-[150%] tracking-[-0.005em] bg-gradient-to-t from-[#46C1BF] to-[#46C1BF] bg-clip-text text-transparent mb-4">
          Our Partners //
        </p>
        <h2 className="font-utility font-medium text-[30px] leading-[120%] tracking-[-0.01em] capitalize text-[#011621] mb-4">
          Trusted By Leading Brands, Powered By Excellence
        </h2>
        <p className="font-inter font-normal text-[18px] leading-[150%] tracking-[-0.005em] text-[#033652]">
          At SKTuff, we collaborate with top glass manufacturers and trusted
          brands across industries to deliver uncompromising quality and
          precision. These partnerships power our ability to innovate and
          deliver world-class glass solutions.
        </p>
      </div>
      <div className="relative overflow-hidden pb-4">
        <div className="flex gap-4 w-[200%] animate-marquee">
          {[...partnerLogos, ...partnerLogos].map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 bg-white p-4 w-[116px] h-[116px] flex items-center justify-center"
            >
              <img
                src={logo}
                alt="Partner Logo"
                className="max-h-full object-contain w-auto mx-auto"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  </>
);

export default PartnersSection;
